<template>
  <div>
    <button id="ia-chat-btn" type="button" @click="toggle">💬</button>

    <div id="ia-chat-frame" v-show="aberto">
      <div id="ia-chat-frame-header">
        <div id="ia-chat-frame-header-info">
          <strong>CajuTec</strong>
          <span>Atendimento com IA</span>
        </div>
        <div id="ia-chat-frame-header-actions">
          <button type="button" title="Limpar atendimento" @click="limparConversa">⟲</button>
          <button type="button" title="Fechar atendimento" @click="fechar">✕</button>
        </div>
      </div>

      <iframe
        v-if="aberto"
        :key="iframeKey"
        :src="atendimentoIaUrl"
        id="ia-chat-frame-iframe"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "EBotaoAtendimentoIA",
  data: () => ({
    aberto: false,
    iframeKey: 0,
    atendimentoIaUrl: process.env.VUE_APP_ATENDIMENTO_IA_URL,
  }),
  methods: {
    toggle() {
      this.aberto = !this.aberto;
    },
    fechar() {
      this.aberto = false;
    },
    limparConversa() {
      this.iframeKey += 1;
    },
  },
};
</script>

<style>
#ia-chat-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #6366f1;
  color: #fff;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.4);
  font-size: 24px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

#ia-chat-btn:hover {
  transform: scale(1.1);
}

#ia-chat-frame {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 380px;
  height: 520px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  z-index: 9998;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#ia-chat-frame-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #6366f1;
  color: #fff;
}

#ia-chat-frame-header-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

#ia-chat-frame-header-info span {
  font-size: 12px;
  opacity: 0.85;
}

#ia-chat-frame-header-actions button {
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  margin-left: 8px;
}

#ia-chat-frame-iframe {
  flex: 1 1 auto;
  width: 100%;
  border: none;
}

@media (max-width: 480px) {
  #ia-chat-frame {
    width: 100%;
    height: 100%;
    bottom: 0;
    right: 0;
    border-radius: 0;
  }
}
</style>
